import React, { useState } from 'react'
import { ReactSVG } from 'react-svg'

interface ToggleProps {
  onChange?: (checked: boolean) => void
  defaultChecked?: boolean
  text?: string
}

const Toggle: React.FC<ToggleProps> = ({ onChange, defaultChecked, text }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked || false)

  const handleChange = () => {
    const newCheckedState = !isChecked
    setIsChecked(newCheckedState)
    if (onChange) {
      onChange(newCheckedState)
    }
  }

  return (
    <div className="toggle">
      <label className={'toggle__label'}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleChange}
          className={'toggle__checkbox'}
        />

        <div className="toggle__icon">
          <ReactSVG
            src={isChecked ? '/i/svg/toggle-on.svg' : '/i/svg/toggle-off.svg'}
            className="svg-icon"
            wrapper="span"
          />
        </div>
      </label>
      <span className="toggle__span">{text}</span>
    </div>
  )
}

export default Toggle
